import { render, staticRenderFns } from "./PopupDestinationUsers.vue?vue&type=template&id=74070763&"
import script from "./PopupDestinationUsers.vue?vue&type=script&lang=js&"
export * from "./PopupDestinationUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports